<template>
    <mm-tab-title v-model="tab" :titles="titles">
        <el-button slot="save" size="medium" type="primary" @click="submit">save</el-button>
        <div>
        <el-form ref="form" :model="result" size="small" label-width="200px">
        
            <div v-show="tab===1">
                <el-form-item label="Adv Name" prop="adv_name"  required>
                    <el-input v-model="result.adv_name" @change="()=>{ result.adv_name = result.adv_name.replace(/\s/ig, '') }" />
                </el-form-item>
                <el-form-item label="Adv Type" required prop="adv_type">
                    <mm-adv-type v-model="result.adv_type" />
                </el-form-item>
                <el-form-item label="Account Level" required prop="account_level">
                    <mm-adv-accountlevel v-model="result.account_level" />
                </el-form-item>
                <el-form-item label="Geo" prop="geo">
                    <mm-offer-geos v-model="result.geo" />
                </el-form-item>
                <el-form-item label="Is Api Source" prop="is_api">
                    <el-switch v-model="result.is_api" :active-value="1" :inactive-value="0" />
                </el-form-item>
                <el-form-item label="New Offer Mail" prop="new_offer_mail">
                    <el-switch v-model="result.new_offer_mail" :active-value="1" :inactive-value="0" />
                </el-form-item>
                <el-form-item label="New Offer Cap Mail" prop="new_offer_cap_mail">
                    <el-switch v-model="result.new_offer_cap_mail" :active-value="1" :inactive-value="0" />
                </el-form-item>
                <el-form-item label="Status" prop="status" required>
                    <el-radio-group v-model="result.status">
                        <el-radio label='active'>active</el-radio>
                        <el-radio label='pending'>pending</el-radio>
                        <el-radio label='paused'>paused</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Redirect Mode" prop="jump_way" required>
                    <el-radio-group v-model="result.jump_way">
                        <el-radio :label='2'>302</el-radio>
                        <el-radio :label='0'>Double meta refresh</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Weight" required prop="weight">
                    <el-input type="number" @mousewheel.native.prevent v-model="result.weight" />
                </el-form-item>
                <el-form-item label="Account Manager" required prop="account_manager">
                    <mm-users v-model="result.account_manager" />
                </el-form-item>
                <el-form-item label="Business Manager" required prop="business_manager">
                    <mm-users v-model="result.business_manager" />
                </el-form-item>
                <el-form-item label="Client Finance Email" prop="client_finance_email" type="email" >
                    <el-input v-model="result.client_finance_email" />
                </el-form-item>
                <el-form-item label="Client Dashboard Addr" prop="client_dashboard_addr" >
                    <el-input v-model="result.client_dashboard_addr" />
                </el-form-item>
                <el-form-item label="IO" prop="io" >
                    <mm-upload v-model="result.io_file" dir="adv"></mm-upload>
                </el-form-item>
                <el-form-item label="Remark" prop="remark"  >
                    <el-input v-model="result.remark" type="textarea" :rows="5" />
                </el-form-item>
                <el-form-item label="Billing Info" prop="billing_info"  >
                    <el-input v-model="result.billing_info" type="textarea" :rows="5" />
                </el-form-item>
            </div>
            <div v-show="tab===2">
                <el-form-item label="track-platform" prop="track_platform">
                    <mm-adv-track-platform v-model="result.track_platform" />
                </el-form-item>
                <el-form-item label="Click Parameters" prop="click_parameters">
                    <el-input v-model="result.click_parameters" placeholder="&aff_sub={clickid}&subid={sub_channel}" />
                </el-form-item>
                <el-form-item label="API URLs" prop="api_url">
                    <mm-adv-api-url v-model="result.api_url" />
                </el-form-item>
                <el-form-item label="Client Conversion Server IPs" prop="ip_white_list">
                    <el-input v-model.trim="result.ip_white_list" type="textarea" :rows="5" placeholder="eg.: 192.168.0.1,192.168.0.2" />
                </el-form-item>
            </div>
        </el-form>

        </div>
    </mm-tab-title>


</template>

<script>
export default {
	props: ["edit"],
	watch:{
		'$route' (to, from) {
			this.loadData();
		}
	},
	data() {
		return {
			result: {
				is_api: true,
                new_offer_mail: false,
                new_offer_cap_mail: false,
				status: 'active',
				jump_way: 2,
			},
			file_list:[],
            tab: 1,
            titles:['Base Info','Tracking Info'],
		};
	},
	methods: {
		async submit() {
			await this.$validate(this.$refs.form);
            const request_path = this.edit?'/advertiser/update':'/advertiser/create';
            const result = await this.$post(request_path,this.result);
			if(this.edit){
				this.loadData();
			}else{
				this.$router.push({ path: "/advEdit",query:{id:result} });
			}
            
		},
		async loadData(){
			if (this.edit) {
				const id= this.$route.query['id'];
				this.result = await this.$post('/advertiser/detail',{adv_id:id});
			}
		}
	},
    
	beforeMount() {
		this.loadData();
	}
};
</script>